import { getCurrentAppByHostname } from '../../Helpers';
import { AnalyticsFiltersForm } from '../../Models';

const AnalyticsSearchStorage = `Smartforce.${
  getCurrentAppByHostname() === 'nexus' ? 'Nexus' : 'CitizenContact'
}.AnalyticsSearchConfig`;

export interface AnalyticsSearchConfigType {
  filters: AnalyticsFiltersForm | undefined;
  wsId?: string;
}

export const getAnalyticsSearchConfig = (
  wsId?: string
): AnalyticsSearchConfigType => {
  const storageKey = wsId
    ? `${AnalyticsSearchStorage}.WS_ID.${wsId}`
    : AnalyticsSearchStorage;

  return localStorage.getItem(storageKey)
    ? JSON.parse(localStorage.getItem(storageKey) as string)
    : { filters: undefined };
};

export const setAnalyticsSearchConfig = (
  filters: AnalyticsSearchConfigType,
  wsId?: string
): void => {
  const storageKey = wsId
    ? `${AnalyticsSearchStorage}.WS_ID.${wsId}`
    : AnalyticsSearchStorage;
  localStorage.setItem(storageKey, JSON.stringify(filters));
};
